import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteService } from "../../api/apiServices";
import parseError from "../../utils/parseError";

const useForceDeleteService = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteSer,
        isPending: isForceDelete,
    } = useMutation({
        mutationFn: forceDeleteService,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["services"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete service");
        },
    });

    return {
        forceDeleteSer,
        isForceDelete,
    };
};

export default useForceDeleteService;
